<template>
  <div class="field-option-customer-info-face-uploader">
    <van-uploader
      v-model="list"
      :max-count="1"
      :style="{ marginTop: '8px' }"
      :before-read="handleBeforeRead"
      :after-read="handleUpload"
      :before-delete="handleDelete"
    >
      <div class="uploader">
        <div class="inner">
          <div v-show="status === 0">
            <van-icon class="icon" name="plus" />
            <p class="text">上传人脸</p>
          </div>
          <div v-show="status === 1">
            <van-loading />
          </div>
        </div>
      </div>
    </van-uploader>
  </div>
</template>

<script>
import { compress } from '../utils/util';
import { createFile } from '../api/api-util';

export default {
  data() {
    return {
      status: 0,
      list: [],
    };
  },
  methods: {
    handleBeforeRead({ size }) {
      if (size > 1024 * 1024 * 5) {
        this.$toast.fail('图片大小不能超过5MB');
        return false;
      }
      this.status = 1;
      return true;
    },
    async handleUpload({ content, file }) {
      this.list = [];
      this.$emit('change', 'loading');
      const compressed = await compress(content);
      const data = await createFile({ image: compressed, path: file.name });
      if (data) {
        this.$emit('change', data);
        this.list = [{ content: compressed, file }];
      }
      this.status = 0;
    },
    handleDelete() {
      this.list = [];
      this.$emit('change', '');
      return true;
    },
  },
};
</script>

<style lang="less" scoped>
.field-option-customer-info-face-uploader {
  .uploader {
    width: 80px;
    height: 100px;
    display: flex;
    color: #969799;
    border-radius: 4px;
    margin: 0 8px 8px 0;
    align-items: center;
    box-sizing: border-box;
    justify-content: center;
    border: 1px dashed #e5e5e5;
    .inner {
      text-align: center;
      .icon {
        font-size: 24px;
      }
      .text {
        margin-top: 2px;
        font-size: 12px;
      }
    }
  }
}
</style>
